import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  GET_ISSUES_SUCCESS,
  GET_ISSUES_LOADING,
  GET_ISSUES_ERROR,
  SUSPEND_LOADING,
  SUSPEND_ERROR,
  SUSPEND_START,
  SUSPEND_SUCCESS,
  SUSPEND_CANCEL,
} from '@src/app/accounts/suspend/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
export type State = {
  readonly loading: boolean;
  suspendSavedResult: Object | null;
  issues: Array<any> | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case GET_ISSUES_SUCCESS:
      case GET_ISSUES_ERROR:
      case SUSPEND_ERROR:
      case SUSPEND_SUCCESS:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case GET_ISSUES_LOADING:
      case SUSPEND_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  issues: (state = null, action) => {
    switch (action.type) {
      case GET_ISSUES_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },

  suspendSavedResult: (state = null, action) => {
    switch (action.type) {
      case SUSPEND_SUCCESS:
      case SUSPEND_ERROR:
        return action.payload;
      case SUSPEND_CANCEL:
      case SUSPEND_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/suspend/reducer.ts